import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportWebsiteData } from "../../../../models/FacilityReportData";
import { LineChart } from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";
import { EditableAISummary } from "../EditableAISummary";

interface IWebsiteSectionProps {
  website?: FacilityReportWebsiteData;
  isDownloading: boolean;
  facilityReportId: string;
}

export const WebsiteSection: React.FunctionComponent<IWebsiteSectionProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const { website, isDownloading, facilityReportId } = props;

  const [timeUnit, setTimeUnit] = useState<"day" | "week" | "month">(
    website?.time_unit ?? "day"
  );

  if (!website) {
    return null;
  }

  return (
    <div className="website-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-website-section"
      >
        <EditableAISummary
          title={t("websiteSection.title")}
          summary={website.ai_summary}
          facilityReportId={facilityReportId}
          patchKey="website"
          isDownloading={isDownloading}
        />
        {!website.website_clicks_data ? (
          <p className="no-data-message">{t("no_data")}</p>
        ) : (
          <>
            <LineChart
              chartDetailsData={website.website_clicks_data}
              usePrevYear={false}
              timeUnit={timeUnit}
              skipLabelTranslation={false}
              setTimeUnit={setTimeUnit}
              showTimeUnitSelect={!isDownloading}
            />
          </>
        )}
      </div>
    </div>
  );
};
